import React, { useEffect, useState } from 'react';

import ColorLineText from '../../atoms/Text/ColorLineText';
import { ItemComboBox, ComboBoxItemType } from '../../atoms/ComboBox/ItemComboBox';
import { ItemComboBoxStr, ComboBoxItemTypeS } from '../../atoms/ComboBox/ItemComboBoxStr';
import {
  MeasureInfoType,
  SelectDataType,
  GetDataTimeList,
  GetComparisonNo,
  CreateDefalutMeasureInfoType,
} from './FFTComparisonConanair';
import ItemCalender from '../../atoms/Calendar/ItemCalender';
import dayjs from 'dayjs';
import ItemCheckBox from '../../atoms/CheckBox/ItemCheckBox';
import Button from '@material-ui/core/Button';
import { Table, TableBody, TableCell, TableRow } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { useModal } from '../../../function/useModal';
import FFTSideBandDiagDialog, { FFTSideBandDiagDialogResponse } from './FFTConanairSideBandDiagDialog';
import DateInput from '../../atoms/Calendar/DateInput';
import { useTranslation } from 'react-i18next';
import { IsValidKindOfFftCmpConan } from '../../../function/NameDevSetModel';
import Box from '@material-ui/core/Box';
import { GetVibrationSpecialString, MeasureHighKind } from '../../../Constant';

const useStyles = makeStyles(
  createStyles({
    cellStyle: {
      padding: '0px',
      borderBottomWidth: '0px',
      fontSize: '12px',
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
    },
    cellStyleNoBorder: {
      padding: '0px',
      borderBottomWidth: '0px',
      fontSize: '12px',
      cursor: 'pointer' /* マウスポインタの形状 */,
    },
    cellSelectStyle: {
      background: 'gold',
      padding: '0px',
      borderBottomWidth: '0px',
      fontSize: '12px',
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
    },
    buttonStyle: {
      maxWidth: '180px',
      maxHeight: '25px',
      minWidth: '50px',
      minHeight: '25px',
    },
    sokuButtonStyle: {
      maxWidth: '200px',
      maxHeight: '25px',
      minWidth: '100px',
      minHeight: '25px',
      fontSize: '12px',
      padding: '1',
    },
    labelStyle: {
      fontSize: '12px',
    },
    itemBoxStyle: {
      fontSize: '12px',
    },
  })
);

export type SelectItemRefreshData = {
  selectData: SelectDataType;
  mesInfoList: MeasureInfoType[];
  fftConanComboBoxList: ComboBoxItemType[];
};

type Props = {
  refreshData: SelectItemRefreshData;
  selectData: SelectDataType;
  itemColor: string;
  measurementName: string;
  onChangeSelectDataEvent: (selectData: SelectDataType) => void;
  onChangeSelectDataDispUpDateEvent: (selectData: SelectDataType) => void;
  isBlankSelect: boolean;
  isUnitSelect: boolean;
  onClickUnitSelect: () => void;
  onAutoRangeSet: (data: boolean) => void;
};

//計測種別リスト作成
const createMeasureList = (data: MeasureInfoType[], isBlankSelect: boolean): ComboBoxItemType[] => {
  var ret: ComboBoxItemType[] = [];
  if (data != null) {
    //コナンエア表示として　有効化を返す
    var targetList = data.filter((r) => IsValidKindOfFftCmpConan(r.Speed, 0));

    var measureList = targetList.filter(
      (el: MeasureInfoType, index, self) =>
        self.findIndex((e: MeasureInfoType) => e.KindNo === el.KindNo && e.MesName === el.MesName) === index
    );
    console.debug(['★★CreateMeasureList', 'measureList', measureList, 'targetList', targetList]);
    for (var i in measureList) {
      ret.push({ index: measureList[i].id, name: measureList[i].MesName });
    }

    //空行追加
    if (isBlankSelect) ret.push({ index: -1, name: '' });
  }
  return ret;
};

//機器種別リスト作成
const createDevList = (data: MeasureInfoType[], measureId: number): ComboBoxItemType[] => {
  var ret: ComboBoxItemType[] = [];
  if (data != null) {
    var data = data.filter((r) => IsValidKindOfFftCmpConan(r.Speed, 0));

    // var mes = data.find((item) => item.id === measureId);
    // console.debug(["★★createDevList - data,mes", data, mes]);
    // //speed2でfilter後、groupby
    var itemNameList = data.filter(
      (el: MeasureInfoType, index, self) =>
        self.findIndex((e: MeasureInfoType) => e.DevIndex === el.DevIndex) === index
    );
    // console.debug(["★★createDevList - itemNameList", itemNameList]);
    if (measureId !== -1) {
      for (var i in itemNameList) {
        ret.push({
          index: itemNameList[i].id,
          name: itemNameList[i].DevNo + itemNameList[i].DevName,
        });
      }
    }
    console.debug(["createDevList - ret", ret]);
  }
  return ret;
};

/**
 * 項目種別リスト作成
 * @param data
 * @param measureId
 * @param devId
 * @returns
 */
const createItemList = (data: MeasureInfoType[], measureId: number, devId: number): ComboBoxItemType[] => {
  let ret: ComboBoxItemType[] = [];
  if (data === null) {
    return ret;
  }

  let targetDatas = data.filter((r) => IsValidKindOfFftCmpConan(r.Speed, 0));
  // let mes = targetDatas.find((item) => item.id === measureId);
  let dev = targetDatas.find((item) => item.id === devId);

  //speed2でfilter後、groupby
  var itemNameList = targetDatas.filter(
    (el: MeasureInfoType, index, self) =>
      self.findIndex(
        (e: MeasureInfoType) =>
          // e.KindNo === mes?.KindNo &&
          e.DevIndex === dev?.DevIndex &&
          e.ItemNameNo === el.ItemNameNo &&
          e.ItemName === el.ItemName
      ) === index
  );

  for (var i in itemNameList) {
    ret.push({ index: itemNameList[i].id, name: itemNameList[i].ItemName });
  }
  return ret;
};

/**
 * 時間リスト作成
 * @param data
 * @returns
 */
export const createTimeList = (data: string[]): ComboBoxItemTypeS[] => {
  var ret: ComboBoxItemTypeS[] = [];
  for (var i in data) {
    var time = dayjs(data[i]).format('HH:mm:ss');
    ret.push({ key: time, name: time });
  }
  return ret;
};

const FFTComparisonConanairSelectItem: React.FC<Props> = (props) => {
  const { t, i18n } = useTranslation();
  const classes = useStyles();
  const [mesInfoList, setMesInfoList] = React.useState<MeasureInfoType[]>([]);

  const [mesList, setMesList] = React.useState<ComboBoxItemType[]>([]);
  const [devList, setDevList] = React.useState<ComboBoxItemType[]>([]);
  const [itemList, setItemList] = React.useState<ComboBoxItemType[]>([]);
  const [envelopeList, setEnvelopeList] = React.useState<ComboBoxItemType[]>([]);
  const [timeList, setTimeList] = useState<ComboBoxItemTypeS[]>();
  const [selectData, setSelectData] = useState<SelectDataType>(props.selectData);
  const [flgSideBand, actSideBand] = useModal<FFTSideBandDiagDialogResponse>();
  const [sbPlcNo, setSbPlcNo] = useState<number>(0);
  const [sbAiCard, setSbAiCard] = useState<number>(0);
  const [sbAiCh, setSbAiCh] = useState<number>(0);
  const [sbTarget, setSbTarget] = useState<string>('');

  /**
   * エンベロープ切替
   */
  useEffect(() => {
    let envelopeList: ComboBoxItemType[] = [];
    envelopeList.push({ index: 0, name: "なし" });
    envelopeList.push({ index: 1, name: "あり" });
    setEnvelopeList(envelopeList);

  }, []);

  /**
   * 計測種別
   * 振動（速度）、振動（変位）のみ多言語切替
   */
  const changeLangMeasCombos = (items: ComboBoxItemType[]) => {
    console.debug(['-- useEffect changeLangMeasCombos --', 'items', items, 'mesInfoList', mesInfoList]);
    if (items?.length) {

      // //振動（速度）
      // const fftSpd = items.find((item) =>
      //   mesInfoList.find(({ id, KindNo }) => item.index === id && KindNo === MeasureHighKind.VIBRATION_SPD)
      // );
      // if (fftSpd) {
      //   fftSpd.name = GetVibrationSpecialString(MeasureHighKind.VIBRATION_SPD, t);
      // }
      // //振動（変位）
      // const fftDsp = items.find((item) =>
      //   mesInfoList.find(({ id, KindNo }) => item.index === id && KindNo === MeasureHighKind.VIBRATION_DSP)
      // );
      // if (fftDsp) {
      //   fftDsp.name = GetVibrationSpecialString(MeasureHighKind.VIBRATION_DSP, t);
      // }

      // console.debug(['fftSpd:', fftSpd, 'fftDsp:', fftDsp]);
      setMesList([...items]);
    }
  };

  // 言語切替
  useEffect(() => {
    console.debug(['FFTComparisonConanairSetting useEffect i18n']);
    changeLangMeasCombos(mesList);
  }, [i18n.language]);

  //コンボボックスデータ作成
  useEffect(() => {
    var dt = props.refreshData;
    console.debug(['FFTComparisonConanairSelectItem useEffect props.refreshData', dt]);
    if (dt !== undefined && dt.mesInfoList.length !== 0) {
      console.debug(dt.selectData);
      var sdt = dt.selectData;
      var mesList: ComboBoxItemType[] = [];
      var devList: ComboBoxItemType[] = [];
      var itemList: ComboBoxItemType[] = [];

      //mesList = createMeasureList(dt.mesInfoList, props.isBlankSelect);
      mesList = props.refreshData.fftConanComboBoxList;


      //console.debug('FFTComparisonSelectItem useEffect -- mesList --', mesList);
      if (mesList.length !== 0) {
        devList = createDevList(dt.mesInfoList, sdt.mesid);
      }
      if (devList.length !== 0) {
        itemList = createItemList(dt.mesInfoList, sdt.mesid, sdt.devid);
      }
      setMesInfoList(dt.mesInfoList);
      setMesList(mesList);
      setDevList(devList);
      setItemList(itemList);

      upDateTimeList(dt.mesInfoList, sdt.mesid, sdt.devid, sdt.itemid, sdt.selectDate, sdt.selectTime);

      props.onChangeSelectDataEvent(dt.selectData);
    }
  }, [props.refreshData]);



  /**
   * 時間選択コンボボックスデータ更新
   * @param measureList
   * @param mesid
   * @param devid
   * @param itemid
   * @param date
   * @param time
   * @returns
   */
  const upDateTimeList = (
    measureList: MeasureInfoType[],
    mesid: number,
    devid: number,
    itemid: number,
    date: Date,
    time: string
  ) => {
    const initSelectData = { ...selectData, mesid: mesid, devid: -1, itemid: -1, selectDate: date, selectTime: '' };
    if (measureList.length === 0) {
      setSelectData({ ...initSelectData });
      props.onChangeSelectDataEvent(initSelectData);
      return;
    }

    //let mes = measureList.find((item) => item.id === mesid);
    let dev = measureList.find((item) => item.id === devid);
    let itemdt = measureList.find((item) => item.id === itemid);
    let day = dayjs(date).format('YYYY-MM-DD');

    if (dev === undefined || itemdt === undefined) {
      setSelectData({ ...initSelectData });
      props.onChangeSelectDataEvent(initSelectData);
      //console.debug(["setSelectData", initSelectData, measureList, selectData]);
      return;
    }

    //対象レコード取得
    let target = measureList.find((item) => {
      return item.DevIndex === dev?.DevIndex && item.ItemNameNo === itemdt?.ItemNameNo && item.Speed === 6;
    });
    console.debug(["★★target, measureList, selectData, day", target, measureList, selectData, day]);
    if (target === undefined) {
      setSelectData({ ...initSelectData });
      props.onChangeSelectDataEvent(initSelectData);
      return;
    }

    let comparisonNo = GetComparisonNo(target);
    //console.debug(["★★target2", Number(target.PlcNo), Number(target.AiCard), Number(target.AiCh), day, comparisonNo, selectData.envelopeNo, mesid])
    //時間リスト取得
    GetDataTimeList(Number(target.PlcNo), Number(target.AiCard), Number(target.AiCh), day, comparisonNo, selectData.envelopeNo, mesid).then((ret) => {
      if (ret) {
        let timeList = createTimeList(ret);

        if (timeList.length === 0) {
          time = '';
        } else {
          if (time !== '') {
            let t = timeList.find((row) => row.key === time);
            if (t === undefined) {
              time = timeList[0].key;
            }
          } else {
            time = timeList[0].key;
          }
        }
        //時間でソートを行う
        timeList.sort(function (a, b) {
          if (a.name > b.name) {
            return 1;
          } else {
            return -1;
          }
        });

        setTimeList(timeList);

        let tmp = { ...selectData, mesid: mesid, devid: devid, itemid: itemid, selectDate: date, selectTime: time };
        setSelectData({ ...tmp });
        props.onChangeSelectDataEvent(tmp);
      }
    });
  };

  /**
   *計測種別変更event
   * @param event
   */
  const onChangeMesSelect = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    props.onAutoRangeSet(true);
    if (Number(event.target.value) == -1) {
      console.debug(["★★noSelect", Number(event.target.value)]);
      let devList = createDevList(mesInfoList, -1);
      let itemList = createItemList(mesInfoList, -1, -1);
      setDevList(devList);
      setItemList(itemList);
      upDateTimeList(mesInfoList, -1, -1, -1, selectData.selectDate, '');
    } else {
      // var mes = mesInfoList.find((item) => item.id === Number(event.target.value));
      var devList = createDevList(mesInfoList, 0);
      var itemList = createItemList(mesInfoList, 0, devList[0].index);
      setDevList(devList);
      setItemList(itemList);
      upDateTimeList(mesInfoList, Number(event.target.value), devList[0].index, itemList[0].index, selectData.selectDate, '');
    }
  };

  /**
   *機器選択変更event
   * @param event
   */
  const onChangeDevSelect = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    // var mes = mesInfoList.find((item) => item.id === selectData.mesid);
    let mesId = selectData.mesid;
    var dev = mesInfoList.find((item) => item.id === Number(event.target.value));
    if (dev !== undefined) {
      var itemList = createItemList(mesInfoList, mesId, dev.id);
      setItemList(itemList);
      upDateTimeList(mesInfoList, mesId, dev.id, itemList[0].index, selectData.selectDate, '');
    }
  };

  /**
   *項目選択変更event
   * @param event
   */
  const onChangeItemSelect = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    // var mes = mesInfoList.find((item) => item.id === selectData.mesid);
    var dev = mesInfoList.find((item) => item.id === selectData.devid);
    var itm = mesInfoList.find((item) => item.id === Number(event.target.value));
    if (dev !== undefined && itm !== undefined) {
      upDateTimeList(mesInfoList, selectData.mesid, dev.id, itm.id, selectData.selectDate, '');
    }
  };

  /**
   * エンベロープ変更event
   * @param event 
   */
  const onChangeEnvelopeSelect = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    // console.debug(['mes--', mes]);
    var tmp = { ...selectData, envelopeNo: Number(event.target.value) };
    setSelectData({ ...tmp });

    console.debug(['handleTimeSelectChange - old,new', selectData, tmp]);
    props.onChangeSelectDataEvent(tmp);
  };

  /**
   * カレンダー選択変更event
   */
  const onCnageSelectCalendarValue = (value: string) => {
    var selectDay = new Date(value);
    upDateTimeList(mesInfoList, selectData.mesid, selectData.devid, selectData.itemid, selectDay, '');
  };
  /**
   * 時間変更event
   * @param event
   */
  const onChangeSelectTime = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    var time = timeList?.find((row) => row.key === event.target.value);
    if (time) {
      var tmp = { ...selectData, selectTime: time.key };
      setSelectData({ ...tmp });
      console.debug(['handleTimeSelectChange - old,new', selectData, tmp]);
      props.onChangeSelectDataEvent(tmp);
    }
  };

  /**
   *表示チェックボックス状態変更時
   */
  const handleIsShowChange = () => {
    var tmp = { ...selectData, isShow: !selectData.isShow };
    setSelectData({ ...tmp });
    props.onChangeSelectDataDispUpDateEvent(tmp);
  };

  const handleIsSelectChange = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    var tmp = { ...selectData, isSelect: !selectData.isSelect };
    setSelectData({ ...tmp });
    props.onChangeSelectDataEvent(tmp);
  };

  /**
   * 閾値設定
   * @param event
   */
  const handleIsThresholdChange = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    var tmp = { ...selectData, isThreshold: !selectData.isThreshold };
    setSelectData({ ...tmp });
    props.onChangeSelectDataDispUpDateEvent(tmp);
  };

  const sideBandDiag = flgSideBand ? (
    <FFTSideBandDiagDialog dialog={actSideBand} plcNo={sbPlcNo} aiCard={sbAiCard} aiCh={sbAiCh} target={sbTarget} />
  ) : null;

  return (
    <>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell className={classes.cellStyle}>
              <Table>
                <TableRow>
                  <TableCell className={classes.cellStyleNoBorder}>
                    <input type="checkbox" checked={selectData.isShow} onChange={() => handleIsShowChange()} />
                  </TableCell>
                  <TableCell
                    className={props.isUnitSelect ? classes.cellSelectStyle : classes.cellStyleNoBorder}
                    onClick={(e) => {
                      props.onClickUnitSelect();
                    }}
                  >
                    {props.measurementName} <ColorLineText height={'8px'} color={props.itemColor} width={'40px'} />
                  </TableCell>
                </TableRow>
              </Table>
            </TableCell>
            <TableCell className={classes.cellStyle}>
              <ItemCheckBox
                label={t('FFTComparisonConanairSelectItem.閾値表示', '閾値表示')}
                labelPosition={1}
                onChangeEvent={(e) => handleIsThresholdChange(e)}
              />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.cellStyle} colSpan={2}>
              <ItemComboBox
                label={t('FFTComparisonConanairSelectItem.計測種別', '計測種別：')}
                itemList={mesList}
                value={selectData.mesid}
                labelStyle={classes.labelStyle}
                itemBoxStyle={classes.itemBoxStyle}
                onChangeEvent={onChangeMesSelect}
              />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.cellStyle} colSpan={2}>
              <ItemComboBox
                label={t('FFTComparisonConanairSelectItem.機器', '機器：')}
                itemList={devList}
                value={selectData.devid}
                labelStyle={classes.labelStyle}
                itemBoxStyle={classes.itemBoxStyle}
                onChangeEvent={onChangeDevSelect}
              />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.cellStyle} colSpan={2}>
              <ItemComboBox
                label={t('FFTComparisonConanairSelectItem.項目', '項目：')}
                itemList={itemList}
                value={selectData.itemid}
                labelStyle={classes.labelStyle}
                itemBoxStyle={classes.itemBoxStyle}
                onChangeEvent={onChangeItemSelect}
              />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.cellStyle}>
              <DateInput
                labelCssString={classes.labelStyle}
                initialValue={dayjs(selectData.selectDate).format('YYYY-MM-DD')}
                label={t('RawWaveformComparisonSelectItem.計測日', '計測日：')}
                labelPosition={1}
                onDateChange={onCnageSelectCalendarValue}
              ></DateInput>
              {/* <ItemCalender
                label={t('FFTComparisonConanairSelectItem.計測日', '計測日：')}
                textCssString={classes.labelStyle}
                labelCssString={classes.labelStyle}
                onChange={onCnageSelectCalendarValue}
                defaultValue={dayjs(selectData.selectDate).format('YYYY-MM-DD')}
              /> */}
            </TableCell>
            <TableCell className={classes.cellStyle}>
              <ItemComboBoxStr
                label={''}
                itemList={timeList}
                value={selectData.selectTime}
                labelStyle={classes.labelStyle}
                itemBoxStyle={classes.itemBoxStyle}
                onChangeEvent={onChangeSelectTime}
              />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.cellStyle}>
              <ItemCheckBox
                label={t('FFTComparisonConanairSelectItem.選択項目', '選択項目')}
                labelPosition={1}
                onChangeEvent={(e) => handleIsSelectChange(e)}
              />
            </TableCell>
            {/* <TableCell className={classes.cellStyle}>
              <ItemComboBox
                label={t('FFTComparisonConanairSelectItem.エンベロープ', 'エンベロープ：')}
                itemList={envelopeList}
                value={selectData.envelopeNo}
                labelStyle={classes.labelStyle}
                itemBoxStyle={classes.itemBoxStyle}
                onChangeEvent={onChangeEnvelopeSelect}
              />
            </TableCell> */}
          </TableRow>
        </TableBody>
      </Table>
      {sideBandDiag}
    </>
  );
};

export default FFTComparisonConanairSelectItem;
